module.exports = __webpack_public_path__ + "media/images/ui-icons_cc0000_256x240-f9c4e8cd979a072fdb3a79641c04a631.png";